module.exports = __webpack_public_path__ + "img/article_status_red.be136340.png";